import { DenialLetterUploadStatus } from "../../../../enums/denialLetterUploadStatus";

export const getTextColorForDenialLetterUploadStatus = (
  status: DenialLetterUploadStatus,
) => {
  if (status === DenialLetterUploadStatus.NOT_INITIATED) return "#F5F5F5";
  if (status === DenialLetterUploadStatus.INITIATED) return "#665D00";
  if (status === DenialLetterUploadStatus.IN_PROGRESS) return "#7B1FA2";
  if (status === DenialLetterUploadStatus.LETTER_NOT_FOUND) return "#111111";
  if (status === DenialLetterUploadStatus.NOT_APPLICABLE) return "#111111";
  if (status === DenialLetterUploadStatus.COMPLETED) return "#005D49";
  if (status === DenialLetterUploadStatus.SUCCESS) return "#005D49";
  if (status === DenialLetterUploadStatus.FAILED) return "#CC0300";
  if (status === DenialLetterUploadStatus.ERROR) return "#CC0300";
  return "#F5F5F5";
};

export const getBgColorForDenialLetterUploadStatus = (
  status: DenialLetterUploadStatus,
) => {
  if (status === DenialLetterUploadStatus.NOT_INITIATED) return "#111111";
  if (status === DenialLetterUploadStatus.INITIATED) return "#FFFCD6";
  if (status === DenialLetterUploadStatus.IN_PROGRESS) return "#F3E5F5";
  if (status === DenialLetterUploadStatus.LETTER_NOT_FOUND) return "#F5F5F5";
  if (status === DenialLetterUploadStatus.NOT_APPLICABLE) return "#F5F5F5";
  if (status === DenialLetterUploadStatus.COMPLETED) return "#E6F3F0";
  if (status === DenialLetterUploadStatus.SUCCESS) return "#E6F3F0";
  if (status === DenialLetterUploadStatus.FAILED) return "#FFE8E8";
  if (status === DenialLetterUploadStatus.ERROR) return "#FFE8E8";
  return "#111111";
};

export const getTextForDenialLetterUploadStatus = (
  status: DenialLetterUploadStatus,
) => {
  if (status === DenialLetterUploadStatus.NOT_INITIATED) return "Not Started";
  if (status === DenialLetterUploadStatus.INITIATED) return "Started";
  if (status === DenialLetterUploadStatus.IN_PROGRESS) return "In Progress";
  if (status === DenialLetterUploadStatus.LETTER_NOT_FOUND) return "Not Found";
  if (status === DenialLetterUploadStatus.NOT_APPLICABLE) return "NA";
  if (status === DenialLetterUploadStatus.COMPLETED) return "Success";
  if (status === DenialLetterUploadStatus.SUCCESS) return "Success";
  if (status === DenialLetterUploadStatus.FAILED) return "Error";
  if (status === DenialLetterUploadStatus.ERROR) return "Error";
  return "Not Started";
};

export const getDenialLetterUploadStatus = (
  status: string,
): { text: string; color: string; bgColor: string } => {
  if (status === DenialLetterUploadStatus.NOT_APPLICABLE) {
    return {
      text: getTextForDenialLetterUploadStatus(
        DenialLetterUploadStatus.NOT_APPLICABLE,
      ),
      color: getTextColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.NOT_APPLICABLE,
      ),
      bgColor: getBgColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.NOT_APPLICABLE,
      ),
    };
  }
  if (
    status === DenialLetterUploadStatus.COMPLETED ||
    status === DenialLetterUploadStatus.SUCCESS
  ) {
    return {
      text: getTextForDenialLetterUploadStatus(
        DenialLetterUploadStatus.COMPLETED,
      ),
      color: getTextColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.COMPLETED,
      ),
      bgColor: getBgColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.COMPLETED,
      ),
    };
  }
  if (
    status === DenialLetterUploadStatus.FAILED ||
    status === DenialLetterUploadStatus.ERROR
  ) {
    return {
      text: getTextForDenialLetterUploadStatus(DenialLetterUploadStatus.ERROR),
      color: getTextColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.ERROR,
      ),
      bgColor: getBgColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.ERROR,
      ),
    };
  }
  if (status === DenialLetterUploadStatus.NOT_INITIATED) {
    return {
      text: getTextForDenialLetterUploadStatus(
        DenialLetterUploadStatus.NOT_INITIATED,
      ),
      color: getTextColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.NOT_INITIATED,
      ),
      bgColor: getBgColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.NOT_INITIATED,
      ),
    };
  }
  if (status === DenialLetterUploadStatus.INITIATED) {
    return {
      text: getTextForDenialLetterUploadStatus(
        DenialLetterUploadStatus.INITIATED,
      ),
      color: getTextColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.INITIATED,
      ),
      bgColor: getBgColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.INITIATED,
      ),
    };
  }
  if (status === DenialLetterUploadStatus.IN_PROGRESS) {
    return {
      text: getTextForDenialLetterUploadStatus(
        DenialLetterUploadStatus.IN_PROGRESS,
      ),
      color: getTextColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.IN_PROGRESS,
      ),
      bgColor: getBgColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.IN_PROGRESS,
      ),
    };
  }
  if (status === DenialLetterUploadStatus.LETTER_NOT_FOUND) {
    return {
      text: getTextForDenialLetterUploadStatus(
        DenialLetterUploadStatus.LETTER_NOT_FOUND,
      ),
      color: getTextColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.LETTER_NOT_FOUND,
      ),
      bgColor: getBgColorForDenialLetterUploadStatus(
        DenialLetterUploadStatus.LETTER_NOT_FOUND,
      ),
    };
  }

  return {
    text: "Not Started",
    color: "#F5F5F5",
    bgColor: "#111111",
  };
};
